/*
 * 応募
 */
$(function () {
  
  /*
   * 応募キャンセル確認ダイアログ
   */
    $('.reservation-cancel-btn').on('click', function () {
    if (!confirm('応募をキャンセルします。よろしいですか？')) {
      return false;
    }
  return true;
  });
  
});
